import React, { useEffect, useState } from 'react';
import {ReactComponent as Logo} from './logo.svg';
import { BrowserRouter, Route, Switch, Link } from "react-router-dom";
import { Auth } from 'aws-amplify';
import CreateRoom from './CreateRoom';
import CreateLiveRoom from './CreateLiveRoom';
import CreateScheduledRoom from './CreateScheduledRoom';
import Room from './Room';
import MyRooms from './MyRooms';
import Scheduled from './Scheduled';
import Admin from './admin/Index';

// export class CustomSignIn extends SignIn {
// 	constructor(props) {
// 		super(props);
// 		this._validAuthStates = ["signIn", "signedOut", "signedUp"];
// 	}

// 	showComponent(theme) {
// 		console.log('hi hi hi hi')
// 		return <>hi</>
// 	}
// }

const App = ({authState, authData}) => {
	const [isAdmin, setIsAdmin] = useState(false);

	useEffect(() => {
		if (authData && authData.signInUserSession)
			setIsAdmin(authData.signInUserSession.idToken.payload['cognito:groups'].includes('Admin'));
	}, [authData]);

	console.log(authData)

	console.log(authState)


	return (
		<div className="App">
			<BrowserRouter>
				<header>
					<Link to='/'>
						<Logo style={{width:125}} />
						<h1>Remote Interview</h1>
					</Link>
				</header>
				{authState && authState === "signedIn" &&
				<>
					<div className="myrooms">
						<Link to="/myrooms">My Rooms</Link>
						{isAdmin && 
							<>
								&nbsp;|&nbsp;
								<Link to="/admin">Admin</Link>
							</>
						}
						&nbsp;|&nbsp;
						<button onClick={() => Auth.signOut()} className="signout">Sign Out</button>
					</div>
					{/* <div className="warning">
						<strong>WARNING:</strong><br/>
						<br/>This is a work in progress.  Please test before an important interview -- especially recordings.<br/><br/>
						Be sure the record indicator on the top right is visible if you are expecting to record.  If it is not visible, it is NOT recording.
					</div> */}
					<Switch> 
						<Route path="/rooms/:room_id">
							<Room />
						</Route>
						<Route path="/myrooms">
							<MyRooms user={authData.username} />
						</Route>
						<Route path="/live">
							<CreateLiveRoom user={authData.username} />
						</Route>
						<Route path="/scheduled/:room_id">
							<Scheduled user={authData.username} />
						</Route>
						<Route path="/schedule">
							<CreateScheduledRoom user={authData.username} />
						</Route>
						{authData && authData.signInUserSession && authData.signInUserSession.idToken.payload['cognito:groups'].includes('Admin') && 
							<Route path="/admin">
								<Admin />
							</Route>
						}
						<Route exact path="/">
							<CreateRoom user={authData.username} />
						</Route>
					</Switch>
				</>	
				}
				{authState && authState === "signIn" && 
					<a href={process.env.REACT_APP_LOGIN_LINK} className="login">Log in with MyID</a>
				}
			</BrowserRouter>
			<footer>
				For support, please call <a href="tel:212-456-4444">212-456-4444</a> or email <a href="mailto:DATG.DL-Tech.Ops.BTSS@disney.com">DATG.DL-Tech.Ops.BTSS@disney.com</a>.<br/>
				For feedback, please reach out to Jared Wiener: <a href="mailto:jared.l.wiener@abc.com">jared.l.wiener@abc.com</a>
			</footer>
		</div>
	);
}

export default App;
